import { generateLeaveBalanceTablePdf, getAllLeaveBalanceGroupedByUser } from '@/api/leave-balances';
import Card from '@/components/Card';
import { Button } from '@/components/ui/button';
import DataTable from '@/components/ui/DataTable';
import { LeaveBalance, LeaveBalanceDTO, LeaveBalanceTableResult } from '@/models/leave-balances.model';
import React, { useEffect, useState } from 'react'
import { createColumns } from './columns';
import { Skeleton } from '@/components/ui/skeleton';
import { useLeaveTypes } from '@/context/LeaveTypesContext';
import { toast } from '@/hooks/use-toast';
import { FileText } from 'lucide-react';


interface Props {
  selectedYear: string;
}
function LeaveBalanceOverviewDataTable({ selectedYear }: Props) {
  const [data, setData] = useState<LeaveBalanceTableResult[]>([]);
  const [updatedAt, setUpdatedAt] = useState<Date | null>(null);
  const { leaveTypes, loading, error } = useLeaveTypes();



  useEffect(() => {
    const getData = async () => {
      try {
        const res = await getAllLeaveBalanceGroupedByUser(Number(selectedYear));
        console.log('res', res);
        setData(res);
      } catch (err) {
        console.error(err);
        toast({
          variant: "destructive",
          title: "Failed to fetch leave balance",
          description: "Please try again later",
        })
      }
    }
    getData();
    // set updatedat to now local time
    setUpdatedAt(new Date());
  }, [selectedYear])


  const handlePdfDownload = async () => {
    try {
      const response = await generateLeaveBalanceTablePdf(Number(selectedYear), data, updatedAt || new Date());
      // If your API returns a blob URL
      if (typeof response === 'string' && response.startsWith('blob:')) {
        // Fetch the actual blob data
        const blobResponse = await fetch(response);
        if (!blobResponse.ok) {
          throw new Error('Failed to fetch blob data');
        }
        const blob = await blobResponse.blob();
        return { blob, blobUrl: response };
      }
      // If your API directly returns a blob-like object
      else if (
        response &&
        typeof response === 'object' &&
        typeof (response as any).size === 'number' &&
        typeof (response as any).type === 'string'
      ) {
        const blobUrl = URL.createObjectURL(response as Blob);
        return { blob: response as Blob, blobUrl };
      }
      // Handle unexpected response type
      else {
        throw new Error('Unexpected response format from generatePayslipPdf');
      }
    } catch (err) {
      console.error("Error getting payslip data", error);
      toast({
        title: "Error retrieving payslip",
        variant: "destructive",
        description: "Please check your internet connection and try again",
      });
      throw error;
    }
  }
  const viewPdf = async () => {
    try {
      const { blobUrl } = await handlePdfDownload();
      window.open(blobUrl, "_blank");
      // Don't revoke the URL immediately since the user may want to download
      // Keep it for a longer time
      setTimeout(() => URL.revokeObjectURL(blobUrl), 60000); // 1 minute
    } catch (error) {
      // Error already handled in getPayslipBlob
    }
  };

  if (!selectedYear || data.length === 0) {
    return <Skeleton className="h-full w-full " />;
  }
  return (
    <Card styles="h-full flex">
      <div className="rounded-md w-full h-full p-5 bg-white outline outline-2 outline-gray-100 flex flex-col">
        <div className="flex  justify-between items-start">
          <div className="flex flex-col gap-3">
            <div className="font-bold mt-2 text-xl">Leave Balance {selectedYear}</div>
            <div className="text-sm text-gray-500 mb-5">
              View the remaining leave balance for each employee for the year.
              <br />
              Last fetched: {updatedAt?.toLocaleString()}
            </div>


          </div>

          <Button type="button" onClick={viewPdf}>
            <FileText />
            <div>Open in PDF</div>
          </Button>
        </div>
        <div className="overflow-auto flex-grow">
          <DataTable
            tableMinWidth='200px'
            // Toolbar={PayRecordsToolbar}
            data={data}
            columns={createColumns(leaveTypes)}
          />
        </div>
      </div>
    </Card>
  )
}

export default LeaveBalanceOverviewDataTable